import { Checkbox, FormGroup, InputGroup } from '@blueprintjs/core';
import { Field, useField } from 'formik';
import { Col, Row } from 'react-flexbox-grid';
import FieldError from '../form/FieldError';
import FormikPhoneInput from '../form/FormikPhoneInput';
import { NotificationSubscription } from '../../lib/actions/UserAction';
import NotificationSubscriptionsPopover from './NotificationSubscriptionsPopover';

type ContactFormGroupProps = {
  name: string;
  label: string;
  notificationSubscriptions?: NotificationSubscription[];
};

export default function ContactFormGroup({
  label,
  name,
  notificationSubscriptions,
}: ContactFormGroupProps) {
  const [{ value: notify }] = useField<boolean>(`${name}.notify`);

  return (
    <Row>
      <Col xs={12} lg={6}>
        <FormGroup label='NAME' labelFor={`${name}.name`}>
          <Field as={InputGroup} name={`${name}.name`} />
          <FieldError name={`${name}.name`} ignoreTouched />
        </FormGroup>
      </Col>
      <Col xs={12} lg={6}>
        <FormGroup label='SEND NOTIFICATIONS' labelFor={`${name}.notify`}>
          <Field as={Checkbox} name={`${name}.notify`} checked={notify}>
            This contact will receive updates concerning this {label} according
            to your organization’s notification configuration. By checking this,
            you confirm you are authorized to authorize FRAYT to send SMS
            messages and emails to this contact.{' '}
            <NotificationSubscriptionsPopover
              notificationSubscriptions={notificationSubscriptions || []}
            />
          </Field>
          <FieldError name={`${name}.notify`} ignoreTouched />
        </FormGroup>
      </Col>
      <Col xs={12} lg={6}>
        <FormGroup label='PHONE' labelFor={`${name}.phone_number`}>
          <FormikPhoneInput
            name={`${name}.phone_number`}
            placeholder='Enter phone number'
            defaultCountry='US'
          />
          <FieldError name={`${name}.phone_number`} ignoreTouched />
        </FormGroup>
      </Col>
      <Col xs={12} lg={6}>
        <FormGroup label='EMAIL' labelFor={`${name}.email`}>
          <Field as={InputGroup} name={`${name}.email`} type='email' />
          <FieldError name={`${name}.email`} ignoreTouched />
        </FormGroup>
      </Col>
    </Row>
  );
}
